import {
    Box,
    Grid,
    Paper,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Button,
    Tooltip,
} from '@mui/material';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUIButton, SCUILoadingLinear } from '../../../../atomic/atoms';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import TimeHelper from '../../../../utils/time';
import { RefundQuery, RefundRestQuery } from '../../../../services/query';
import Helper from '../../../../utils/helper';
import { CRFV2 } from './customerRefundListV2.classes';

const other_link: any = import.meta.env.VITE_APPURL!;

export const CustomerRefundListV2: FC<any> = ({ datas }) => {
    const [loading, setLoading] = React.useState(false);
    const [list, setList] = React.useState([]);
    const [refundStatusList, setRefundStatusList] = React.useState([]);
    const [orderNumber, SetOrderNumber] = React.useState('');
    const [refundStatusId, setRefundStatusId] = React.useState(-1);

    const { t } = useTranslation();

    const GetRefundStatusList = () => {
        RefundQuery.GetRefundStatusList().then((res: any) => {
            let parseRefundStatusList = (res || []).map((item: any) => {
                return {
                    key: item.statusName,
                    value: item.refundStatusId,
                };
            });
            setRefundStatusList(parseRefundStatusList || []);
        });
    };

    const handleChange = (event: any) => {
        setRefundStatusId(event.target.value);
    };

    const GetCustomerOptInByCustomerIdList = async () => {
        setLoading(true);
        let params: any = {
            customerId: datas.customer.customerId,
            orderNumber: orderNumber,
            RefundStatus: refundStatusId,
        };
        RefundRestQuery.RefundList(params)
            .then((res: any) => {
                if (res.items) {
                    let parseData = res.items.map((item: any) => {
                        return {
                            orderNumber: item.orderNumber || '-',
                            date: TimeHelper.formatDateHour(item.date) || '-',
                            customer: item.customerFirstName + ' ' + item.customerLastName || '',
                            reference: item.referenceId || '',
                            refundName: Helper.getRefundReasonName(item.refundReasonId) || '-',
                            statusName: item.refundStatusName || '-',
                            description: item.description || '-',
                            amount: Helper.formatNumber(item.amount) || '-',
                            refundId: item.refundId || '-',
                        };
                    });
                    setList(parseData);
                }
            })

            .finally(() => {
                setLoading(false);
            });
    };

    const columns: ExtendedGridColDef[] = [
        {
            field: 'refundId',
            headerName: 'RefundId',
            flex: 1,
            renderCell: (params) => {
                const onclick = () => {
                    window.open(other_link + '/RefundV2/?id=' + params.row.refundId, '_blank');
                };
                return (
                    <div>
                        <Button className={CRFV2.inputButtonRefundId} onClick={onclick}>
                            <b> {params.row.refundId}</b>
                        </Button>
                    </div>
                );
            },
        },
        {
            field: 'orderNumber',
            headerName: 'Order Number',
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={params.row.orderNumber}>
                            <p>{params.row.orderNumber}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        { field: 'date', headerName: t('general.date'), flex: 1 },
        { field: 'reference', headerName: 'Ref', flex: 1 },
        { field: 'refundName', headerName: t('refundList.refundReasonDesc'), flex: 1 },
        {
            field: 'statusName',
            headerName: t('refund.paymentStatus'),
            flex: 1,
            renderCell: (params: any) => {
                return t(params.row.statusName);
            },
        },
        {
            field: 'description',
            headerName: t('general.description'),

            flex: 1,
            renderCell: (params: any) => {
                return (
                    <div style={{ padding: 5, fontSize: 12, fontWeight: 'bold' }}>
                        <Tooltip title={params.row.description}>
                            <p>{params.row.description}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        { field: 'amount', headerName: t('general.cost'), width: 80 },
    ];

    useEffect(() => {
        GetRefundStatusList();
        GetCustomerOptInByCustomerIdList();
    }, []);

    return (
        <Paper sx={{ padding: '16px' }} className={CRFV2.page}>
            <SCUILoadingLinear display={loading} />
            <Grid className={CRFV2.filtersRow} sx={{ display: 'flex', gap: '1rem' }}>
                <Grid
                    sx={{ marginTop: '1.5rem', paddingLeft: '1rem' }}
                    size={{
                        xl: 2,
                        lg: 2,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <TextField
                        className={CRFV2.inputTextfieldOrderNo}
                        id="outlined-controlled"
                        label={t('general.orderNo')}
                        value={orderNumber}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            SetOrderNumber(event.target.value);
                        }}
                    />
                </Grid>
                <Grid
                    sx={{ marginTop: '1.5rem' }}
                    size={{
                        xl: 2,
                        lg: 2,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <FormControl className={CRFV2.fieldRefundStatus} fullWidth>
                        <InputLabel id="demo-simple-select-label">{t('refund.paymentStatus')}</InputLabel>
                        <Select
                            className={CRFV2.inputSelectRefundStatus}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={refundStatusId}
                            label={t('refund.paymentStatus')}
                            onChange={handleChange}
                        >
                            {refundStatusList &&
                                refundStatusList.map((dist: any) => (
                                    <MenuItem key={dist.value} id={dist.value} value={dist.value}>
                                        {t(dist.key)}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid
                    sx={{ marginTop: '1.5rem' }}
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 2,
                        xl: 2,
                    }}
                >
                    <SCUIButton
                        className={CRFV2.inputButtonSearch}
                        text={t('general.search')}
                        type="primary"
                        sizeType="fixed"
                        style={{ height: '35px' }}
                        buttonType="submit"
                        size={'m'}
                        onClick={() => {
                            GetCustomerOptInByCustomerIdList();
                            setLoading(true);
                        }}
                    />
                </Grid>
            </Grid>
            <Box className={CRFV2.datagrid}>
                <SCUICustomDataGrid
                    randomId
                    rows={list}
                    columns={columns}
                    // getRowHeight={() => 'auto'}
                />
            </Box>
        </Paper>
    );
};
